<template>
    <div class="d-lg-flex half bg-white w-100">
      <div 
        class="bg order-1 order-md-2 auth-bg d-none d-lg-block" 
        :style="{'background-image': 'url(' + require('@/assets/images/auth/' + $i18n.locale +  '/welcome-np.svg') + ')'}" v-if="!isVerified">
      </div>
      <div class="contents order-2 order-md-1">
            <div class="container">
                <div class="row align-items-center justify-content-center">
                    <div class="col-md-7 text-center">              
                        <div class="cobalt-auth mb-4 text-lg-center">
                            <img :src="require('@/assets/images/auth/' + $i18n.locale +  '/registration.svg')" :alt="$t('auth.registration')"  v-if="isVerified" />
                        </div>

                        <div v-if="needReActivate">
                            <p class="cobalt-auth cobalt_color-halfblack mb-4 text-lg-center" style="white-space: pre">
                                {{ $t("auth.verifyWelcome") }}
                            </p>                            
                            <div class="cobalt-input-group">
                                <span class="input-group-text">
                                    <img src="@/assets/images/auth/email.svg" />
                                </span>                            
                                <input type="text" class="form-control cobalt-flat-input cobalt-input-auth" :placeholder="$t('auth.email')"
                                    id="inputEmail" aria-describedby="emailHelp" v-model="email" required>
                            </div>
                            <small id="emailHelp" class="form-text text-muted"></small>                     
                            <div class="cobalt-form-group d-flex mt-4">
                                <button type="button" class="btn cobalt-btn-primary btn-lg flex-fill" :disabled="isLoading" @click="tryReActivate">
                                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" v-if="isLoading"></span>
                                    {{ $t("auth.sendCodeAgain") }}
                                </button>
                            </div>
                            <div v-if="errorReActivation">
                                <p class="mt-2 mb-0 text-danger">{{ errorText }}</p>
                            </div>
                        </div>

                        <div v-if="isVerified">
                            <div class="cobalt-auth mb-4 text-lg-left">
                                <img :src="require('@/assets/images/auth/' + $i18n.locale +  '/invite.svg')" :alt="$t('auth.registration')" />
                                <p class="mt-4">
                                    {{ $t("auth.activationSuccess") }}
                                </p>
                            </div>

                            <div class="cobalt-auth mb-4 text-lg-left">
                                <p>
                                    <a href="../login">{{ $t("auth.login") }}</a> {{ $t("auth.userLoginAndPass") }}
                                </p>
                            </div>
                        </div>

                        <div v-if="isReActivated">
                            <div class="cobalt-auth mb-4 text-lg-left">
                                <p class="mt-4">
                                    {{ $t("message.needReActivation") }}
                                </p>
                            </div>
                        </div>                        
                    </div>
                </div>
            </div>
        </div>
    </div> 
</template>

<script>
import { mapActions } from 'vuex';

export default {
    data() {
        return {
            email: '',
            errorText: '',
            isLoading: false,
            isVerified: false,
            isReActivated: false,
            needReActivate: false,
            errorReActivation: false
        }
    },
    computed: {
        code() {
            return this.$route.query.key || null;
        }
    },
    mounted() {
        this.tryToVerify()
    },
    methods: {
        ...mapActions('user', ['activate', 'resendCode']),

        async tryToVerify() {
            this.isLoading = true

            let result = await this.activate(this.code)

            if (result) {
                this.needReActivate = false
                this.isVerified = true
            } else {
                this.isVerified = false
                this.isReActivated = false
                this.needReActivate = true
            }

            this.isLoading = false
        },

        async tryReActivate() {
            this.errorReActivation = false 

            if (this.email == '') {
                this.errorText = this.$t("error.code0")
                this.errorReActivation = true 
                return
            }

            this.isLoading = true

            let result = await this.resendCode(this.email)

            if (result) {
                if (result.code == 0 || result.code == 2003) {
                    this.errorText = this.$t("error.code0")
                    this.errorReActivation = true 
                } else {
                    if (result.code == 2) {
                        this.errorText = this.$t("auth.forgetDescription")
                        this.errorReActivation = true 
                    } else {
                        this.isReActivated = true
                        this.isVerified = false
                        this.errorReActivation = false
                        this.needReActivate = false
                    }
                }
            } else {
                this.needReActivate = true
            }

            this.isLoading = false
        }        
    }
}
</script>
